import {ElLoading} from "element-plus";


let apiLoadingCount = 0;

let loadingInstance ;

// 打开进度条
export const apiLoadingStart = () => {
    if(apiLoadingCount === 0){
        loadingInstance = ElLoading.service(
            {
                "target":"body",
                "fullscreen":true,
                "text":"",
                "customClass":"my-loading",
                "spinner": '',
                "background" : 'rgba(255, 255, 255, 0.2)',
                "lock" : true
            }
        )
    }
    apiLoadingCount++;
}

// 关闭进度条
export const apiLoadingClose = () => {
    apiLoadingCount--;
    if(apiLoadingCount < 0){
        apiLoadingCount = 0;
    }
    let progressLoadingClose = setTimeout(function(){
        if(apiLoadingCount === 0){
            loadingInstance.close()
        }else {
            clearTimeout(progressLoadingClose)
        }
    },200)

}

